import { TokenLogout } from "API/Logout/logout";
import axios from "axios";

const url2=process.env.REACT_APP_APPROVAL_URL

export const GetBankDetails=async(setData)=>{
    try {
        await axios.get(`${url2}/bank_info`,{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('token')}`
            }
        })
       .then((res)=>{
            setData(res.data)
       })
        
    } catch (error) {
        TokenLogout(error)
        console.log(error);
    }
}